import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalConfig} from '../../../model/modal-config';
import {PageNames} from '../../../shared/page-names.enum';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {Order} from '../../../model/order';

@Component({
  selector: 'app-order-message',
  templateUrl: './order-message.component.html',
  styleUrls: ['./order-message.component.less']
})
export class OrderMessageComponent  implements AfterViewInit {

  @Input()
  config: ModalConfig;

  @Input()
  order: Order;

  @Output()
  emitCloseOrderMessage = new EventEmitter<Object>();
  @Output()
  emitOnBack = new EventEmitter<Object>();

  componentName = PageNames.ORDERING_MESSAGE;
  orderMessageParams = {packageName: ''};

  constructor(protected navigationService: NavigationService, private changeDetector: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.orderMessageParams.packageName = this.order.orderName();
    this.navigationService.resetNavigation();
    this.changeDetector.detectChanges();
  }

  public onEmitCloseOrderMessage(): void {
    this.emitCloseOrderMessage.emit({});
  }

  onBack(): void {
    this.emitOnBack.emit({
      value: true
    });
  }

}
